var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Identity"},[_c('div',{staticClass:"input_box"},[_c('Input',{attrs:{"params":_vm.propsVal,"errorMessage":_vm.errorMessage,"allowClearHandler":_vm.allowClearHandler,"form":_vm.form},model:{value:(_vm.col),callback:function ($$v) {_vm.col=$$v},expression:"col"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }